<div class="mb-1" *ngIf="viewing_item.bins_sorted">
    <h4 class="text-center mt-1 m-0 p-0">Single Item Scan To Bin</h4>
    <hr class="w-100 m-0 p-0">
    <div class="bin-header" *ngIf="!this.frombin">Current Bin Details</div>
    <ul class="entry-list mb-2 mt-1">
        <li *ngFor="let loc of viewing_item.bins_sorted" [ngClass]="{ 
            'empty-bin': loc.quantity == '0', 
            'active-bin bordered': this.startbin.getRawValue().toLowerCase() == loc.bin.toLowerCase(), 
            'd-none': this.startbin.getRawValue() != '' && this.startbin.getRawValue().toLowerCase() != loc.bin.toLowerCase()}" >
            <div *ngIf="loc.defaultbin === '1'" class="w-100 m-0 p-0 row">
                <div class="spec-label">
                    <span *ngIf="loc.bin === ''"><i>N/A</i></span>
                    <span *ngIf="loc.bin !== ''">{{ loc.bin }}</span>
                </div>
                <div class="spec-value">
                    <span>{{ loc.quantity }}</span>
                </div>
            </div>
        </li>
        <li *ngFor="let loc of viewing_item.bins_sorted" [ngClass]="{ 
            'empty-bin': loc.quantity == '0', 
            'active-bin bordered': this.startbin.getRawValue().toLowerCase() == loc.bin.toLowerCase(), 
            'd-none': this.startbin.getRawValue() != '' && this.startbin.getRawValue().toLowerCase() != loc.bin.toLowerCase()}" >
            <div *ngIf="loc.defaultbin === '0'" class="w-100 m-0 p-0 row" >
                <div class="spec-label">
                    <span *ngIf="loc.bin === ''"><i>N/A</i></span>
                    <span *ngIf="loc.bin !== ''">{{ loc.bin }}</span>
                </div>
                <div class="spec-value">
                    <span>{{ loc.quantity }}</span>
                </div>
            </div>
        </li>
    </ul>
        
       

        <!-- 320 x 489 viewport  -->
        <!-- <ng-container *ngFor="let loc of viewing_item.bins_sorted">
            <div class="bin-item d-block" [ngClass]="{ 'empty-bin': loc.quantity == '0', 'active-bin': this.startbin.getRawValue().toLowerCase() == loc.bin.toLowerCase()}" *ngIf="loc.defaultbin === '1' ">
                <div class="row justify-content-around">
                    <div class="bin-label">
                        <span *ngIf="loc.bin === ''"><i>N/A</i></span>
                        <span *ngIf="loc.bin !== ''">{{ loc.bin }}</span>
                    </div>
                    <div class="bin-quantity">
                        <span>{{ loc.quantity }}</span>
                    </div>
                </div>
            </div>
        </ng-container> -->
        <!-- <ng-container *ngFor="let loc of viewing_item.bins_sorted">
            <div class="bin-item" [ngClass]="{ 'empty-bin': loc.quantity == '0', 'active-bin': this.startbin.getRawValue().toLowerCase() == loc.bin.toLowerCase()}" *ngIf="loc.defaultbin != '1' && loc.quantity > 0">
                <div class="bin-label">
                    <span *ngIf="loc.bin === ''"><i>N/A</i></span>
                    <span *ngIf="loc.bin !== ''">{{ loc.bin }}</span>
                </div>
                <div class="bin-quantity">
                    <span>{{ loc.quantity }}</span>
                </div>
            </div>
        </ng-container> -->


    <div class="input-container d-flex justify-content-center m-auto mt-1" id="scan-box">
        <div class="scanner-input-display w-100 m-0 p-0" [class.scanning]="isScanning" [class.error]="scanStatus === 'error'" [class.warning]="scanStatus === 'warning'" [class.processing]="scanStatus === 'processing'">
            <div class="scanner-status" *ngIf="!isMobile">
                <mat-icon class="scanner-icon">
                    {{ scanStatus === 'error' ? 'error' : 
                    scanStatus === 'warning' ? 'warning' : 
                    scanStatus === 'processing' ? 'hourglass_empty' : 
                    isScanning ? 'scanner' : (isSearchMode ? 'search' : 'keyboard') }}
                </mat-icon>
                <span class="scanner-label">
                    {{ statusMessage || (isScanning ? 'Scanning...' : (isSearchMode ? 'Ready to search' : 'Ready to scan')) }}
                </span>
            </div>

            <!-- Scanner Mode Input -->
            <div class="scanner-input" *ngIf="!isSearchMode" [class.mobile-tappable]="isMobile">
                <ng-container *ngIf="isMobile">
                    <div class="row w-100 m-0 p-0 ">
                        <span class="input-value">{{ keyBuffer || statusMessage }}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isMobile">

                    <span class="input-value">{{ keyBuffer || (scannerstatus) }}</span>
                </ng-container>
            </div>
        </div>


        <!-- Hidden input field for keyboard prevention -->
        <input #hiddenScanInput type="text" [formControl]="hiddenScanControl" class="hidden-scan-input" (focus)="onHiddenInputFocus()" (keydown)="onHiddenInputKeyDown($event)" autocomplete="off" tabindex="-1">
    </div>



        <div class="input-container mt-3 mb-3 justify-content-between" [ngClass]="{'input-border': currentStep == 1}">
            <input type="text" #searchRef [formControl]="startbin" id="searchRef" autocomplete="off" placeholder="Scan starting bin..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault();  $event.target.blur();" />
            <span *ngIf="startbin.getRawValue().length">START BIN</span>
            <!-- <button class="search-button" type="button">
                <ng-container *ngIf="!startbin.getRawValue().length">
                    <mat-icon>close</mat-icon>
                </ng-container>
                <ng-container *ngIf="startbin.getRawValue().length">
                    <mat-icon>check</mat-icon>
                </ng-container>            
            </button> -->
        </div>

        <div class="input-container mb-3" [ngClass]="{'container-disabled': item.disabled, 'container-focused': editingCount, 'input-border': currentStep == 2}">
            <!-- item stockid selection -->
            <div class="row m-0 p-0 justify-content-between w-100">
                
                <div class="d-flex row m-0 p-0" [ngClass]="{'col-12': !item.getRawValue().length, 'col-8':item.getRawValue().length}">
                    <input class="w-100" type="text" #searchRef [formControl]="item" id="searchRef" autocomplete="off" placeholder="Scan item..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault();  $event.target.blur();" />
                </div>    

                <!-- item move count input : active after item selection -->
                <div class="col-4 m-0 p-0 d-flex row justify-content-around" *ngIf="item.getRawValue().length">
                    <input class="w-100 text-right pr-0" type="text" id="itemCountRef" [formControl]="itemcount" autocomplete="off" placeholder="Scan item..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault();  $event.target.blur();" />
                    <button class="search-button" type="button" (click)="!confirmedMoveAmount ? confirmAmount() : allowedits()">
                        <ng-container *ngIf="!confirmedMoveAmount">
                            <button mat-mini-fab class="btn-warning">
                                <mat-icon>lock</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="item.getRawValue().length && confirmedMoveAmount && keyboardListenerEnabled">
                            <mat-icon>check</mat-icon>
                        </ng-container> 
                        <ng-container *ngIf="item.getRawValue().length && confirmedMoveAmount && !keyboardListenerEnabled">
                            <button mat-mini-fab class="btn-warning">
                                <mat-icon>lock</mat-icon>
                            </button>
                        </ng-container> 
                    </button>
                </div>

            </div>
        </div>


        <div class="input-container mb-3 justify-content-between" [ngClass]="{'container-disabled': endbin.disabled, 'input-border': currentStep == 3}">
            <input type="text" #searchRef [formControl]="endbin" id="searchRef" autocomplete="off" placeholder="Scan final bin..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault();  $event.target.blur();" />
            <span *ngIf="endbin.getRawValue().length">END BIN</span>
            <!-- <button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault();">
                <ng-container *ngIf="!endbin.getRawValue().length">
                    <mat-icon>close</mat-icon>
                </ng-container>
                <ng-container *ngIf="endbin.getRawValue().length">
                    <mat-icon>check</mat-icon>
                </ng-container> 
            </button> -->
        </div>

        <div class="input-container mb-3 justify-content-between" [ngClass]="{'container-disabled': confirmitem.disabled, 'input-border': currentStep == 4}">
            <input type="text" #searchRef [formControl]="confirmitem" id="searchRef" autocomplete="off" placeholder="Scan item again..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault();  $event.target.blur();" />
            <span *ngIf="confirmitem.getRawValue().length">CONFIRMED</span>
            <!-- <button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault();">
                <ng-container *ngIf="!confirmitem.getRawValue().length">
                    <mat-icon>close</mat-icon>
                </ng-container>
                <ng-container *ngIf="confirmitem.getRawValue().length">
                    <mat-icon>check</mat-icon>
                </ng-container> 
            </button> -->
        </div>

        <div class="w-75 justify-content-around row d-flex m-auto">
            <button mat-raised-button class="btn-danger" (click)="reset()">Reset</button>
            <button mat-raised-button class="btn-success" (click)="confirm()" [disabled]="!confirmable">Confirm</button>
        </div>

    <div class="w-100" style="height: 200px !important"></div>
</div>